
      <nz-page-header class="site-page-header" nzTitle="Create Short URL"></nz-page-header>
    

 

    <nz-card>
        <form >
        

                  <nz-form-item nz-row  nzJustify="center">
                <nz-form-label nz-col [nzSpan]="4" nzLabelAlign="left"nzRequired nzFor="number">Name</nz-form-label>
                <nz-form-control nz-col [nzSpan]="9" nzErrorTip="*Required" >
                  <input nz-input  placeholder="Name" />
                </nz-form-control>
              </nz-form-item> 
              
             
            <nz-form-item nz-row  nzJustify="center">
                <nz-form-label nz-col [nzSpan]="4" nzLabelAlign="left"nzRequired nzFor="number">Is Active</nz-form-label>
                <nz-form-control nz-col [nzSpan]="9" nzErrorTip="*Required" >
                    <nz-radio-group id="fallbackSms">
                        <label nz-radio nzValue="yes">Yes</label>
                        <label nz-radio nzValue="no">No</label>
                    </nz-radio-group>
        
                </nz-form-control>
              </nz-form-item> 



              <nz-form-item nz-row  nzJustify="center">
                <nz-form-label nz-col [nzSpan]="4" nzLabelAlign="left"nzRequired nzFor="number">Is Daynamic</nz-form-label>
                <nz-form-control nz-col [nzSpan]="9" nzErrorTip="*Required" >
                    <nz-radio-group id="fallbackSms">
                        <label nz-radio nzValue="yes">Yes</label>
                        <label nz-radio nzValue="no">No</label>
                    </nz-radio-group>
                    <p style="margin-top: 8px; color: gray;"> If is dynamic is selected different short url will be sent on each number </p>
        
                </nz-form-control>
                
              </nz-form-item> 



              <nz-form-item nz-row  nzJustify="center">
                <nz-form-label nz-col [nzSpan]="4" nzLabelAlign="left"nzRequired nzFor="number">Select Domain</nz-form-label>
                <nz-form-control nz-col [nzSpan]="9" nzErrorTip="*Required" >
                    <nz-select id=""
                    nzPlaceHolder="Select Status">
                    <nz-option></nz-option>
                    </nz-select>
                </nz-form-control>
              </nz-form-item> 

                
              
              <nz-form-item nz-row  nzJustify="center">
                <nz-form-label nz-col [nzSpan]="4" nzLabelAlign="left"nzRequired nzFor="number">Long Url</nz-form-label>
                <nz-form-control nz-col [nzSpan]="9" nzErrorTip="*Required" >
                    <input nz-input  placeholder="Long Url" />
                </nz-form-control>
              </nz-form-item> 



              <nz-form-item nz-row  nzJustify="center">
                <nz-form-label nz-col [nzSpan]="4" nzLabelAlign="left"nzRequired nzFor="number">Callback Url</nz-form-label>
                <nz-form-control nz-col [nzSpan]="9" nzErrorTip="*Required" >
                    <input nz-input placeholder="Callback Url" />
                    <ng-template #prefixTemplate>
            
                  </ng-template>
                  <p style="margin-top: 8px; color: gray;"> 
                  <B> Sample URL </B> : google.com?mobile=%MOBILE%&camp=%CAMPAIGN_NAME%&rectime=%RECTIME%&circle=%CIRCLE%&operator=%OPERATOR% </p>

                </nz-form-control>

              </nz-form-item> 

        
            
        
        
              
                <div class="centered-buttons">
                  <button nz-button nzType="default"  class="action-button" style="margin-left: 450px;">
                    Submit
                  </button>
                  <button nz-button nzType="primary" type="submit" class="action-button" style="margin-left: 20px;" >
                   Back
                  </button>
                </div>
            

            
        </form>
    
    </nz-card> 